import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-filter-resume' },
  selector: 'pulse-filter-resume',
  templateUrl: './filter-resume.component.html',
  styleUrls: ['./filter-resume.component.scss'],
})
export class FilterResumeComponent implements OnInit {
  @Input() filter: any;
  @Input() isPreview: boolean;
  @Output() resetEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  resetValue() {
    this.resetEvent.emit();
  }

  goBack() {
    window.history.back();
  }
}
